
import { Bar, Doughnut, Line, Pie } from "react-chartjs-2";


export default function TrafficChart({ backgroundColor, stepSize, label, hasTitle, title, lables, values, type, dataBackgroundColor, borderColor, hasLegend=false, legendText, legendColor, xTicksColor, yTicksColor, hasXTitleText=false, hasYTitleText=false, xTitleText, yTitleText, tension=null, fill=null, cutout=null, barThickness=null}) {
  const data = {
    labels:lables,//["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"]
    datasets: [
      {
        label: label, //"Page Views"
        data: values, //[120, 190, 300, 250, 220, 400, 380]
        backgroundColor: dataBackgroundColor,
        borderColor: borderColor,
        tension: tension, //0.4 => Line
        fill: fill, // true/false => Line
        cutout: cutout, // 70% => Doughnut
        barThickness: barThickness // 30 => Bar
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      title:{ // chart top title
        display:hasTitle,
        text:title,
        color: legendColor,
        font: {
          size: 21,
          weight: "bold",
        },
        padding:{top: 0, left: 0, right: 0, bottom: 30}
      },
      legend: { // chart each 
        title:{
          display:hasLegend,
          text:legendText,
        },
        display: hasLegend,
        color: legendColor
      },
    },
    scales: type==="Bar"||type==="Line" ? {
      x: {
        title: {
          display: hasXTitleText,
          text: xTitleText,
          color: xTicksColor,
          font: {
            family: 'Comic Sans MS',
            size: 20,
            weight: 'bold',
            lineHeight: 1.2,
          },
          padding: {top: 10, left: 0, right: 0, bottom: 30}
        },
        ticks: {
          color: xTicksColor,
        },
      },
      y: {
        title: {
          display: hasYTitleText,
          text: yTitleText,
          color: yTicksColor,
          font: {
            family: 'Comic Sans MS',
            size: 20,
            weight: 'bold',
            lineHeight: 1.2,
          },
          padding: {top: 30, left: 0, right: 0, bottom: 10}
        },
        ticks: {
          color: yTicksColor,
          stepSize:stepSize,
        },
      },
    } : null,
    tooltip: {
      titleColor: xTicksColor,
      bodyColor: borderColor,
    },
  };
  const getElement = ()=>{
    switch(type){
      case "Line":return <Line data={data} options={options} />;
      case "Bar":return <Bar data={data} options={options} />;
      case "Pie":return <Pie data={data} options={options} />;
      case "Doughnut":return <Doughnut data={data} options={options} />;
    }
  }
  return (
    <div style={{display:"flex", alignItems:"center", justifyContent:"center",width:"80%", margin:"50px auto",borderRadius:"10px", padding:"50px 40px 0", backgroundColor:backgroundColor}}>
      {getElement()}
    </div>
  );
}
